module.exports = __webpack_public_path__ + "media/images/map-blue-4677b7532e777b91a11687e6e8140a25.jpeg";